"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TokenType;
(function (TokenType) {
    TokenType["PUBLIC"] = "public";
    TokenType["STOPNGO"] = "stopngo";
    TokenType["PRIVATE"] = "private";
    TokenType["OTP"] = "otp";
    TokenType["RESET"] = "reset";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
